import type { ReactNode } from "react";
import { AlertCircle, Inbox, LoaderCircle } from "lucide-react";

export function PageHeader({ eyebrow, title, description, actions }: { eyebrow?: string; title: string; description: string; actions?: ReactNode }) {
  return <div className="page-header"><div>{eyebrow && <span className="eyebrow">{eyebrow}</span>}<h2>{title}</h2><p>{description}</p></div>{actions && <div className="page-actions">{actions}</div>}</div>;
}

export function StatusBadge({ value }: { value: string }) {
  const state = value.toLowerCase().replaceAll("_", "-");
  return <span className={`status status-${state}`}><i />{value.replaceAll("_", " ")}</span>;
}

export function LoadingState({ label = "Loading workspace" }: { label?: string }) {
  return <div className="state-card"><LoaderCircle className="spin" size={24} /><strong>{label}</strong><span>Retrieving the latest verified data.</span></div>;
}

export function ErrorState({ error, retry }: { error: Error; retry?: () => void }) {
  return <div className="state-card error"><AlertCircle size={25} /><strong>We couldn’t load this data</strong><span>{error.message}</span>{retry && <button className="button secondary" onClick={retry}>Try again</button>}</div>;
}

export function EmptyState({ title, description, action }: { title: string; description: string; action?: ReactNode }) {
  return <div className="state-card"><span className="state-icon"><Inbox size={23} /></span><strong>{title}</strong><span>{description}</span>{action}</div>;
}
